import { lazy, Suspense } from 'react';
import RouteGuard from '../routerPermission';
import RouteErrorBoundary from '@/shared/ui/error/RouteErrorBoundary';
import SuspenseLoading from '@/shared/ui/loading/suspenseLoading/SuspenseLoading';

const LegalSupportPage = lazy(
  () => import('@/pages/system-admin/legal-support/LegalSupportPage'),
);

const wrap = (element: React.ReactElement) => (
  <RouteErrorBoundary>
    <Suspense fallback={<SuspenseLoading />}>
      {element}
    </Suspense>
  </RouteErrorBoundary>
);

const SystemLegalSupportRoutes = {
  path: 'legal-support',
  children: [
    {
      index: true,
      element: (
        <RouteGuard roles={['SUPER_ADMIN']}>
          {wrap(<LegalSupportPage />)}
        </RouteGuard>
      ),
    },
  ],
};

export default SystemLegalSupportRoutes;
